"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const GasPumpWithTick = (props) => {
    const { width, height, color, tickColor } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 64 71", "data-testID": "GasPumpTransaction" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 0h64v64H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M38 52V14.857C38 13.194 36.841 12 35.13 12H18.87C17.159 12 16 13.194 16 14.857V52m25 0H13m25-24H16m35-6-5 5.333V30h5m-13 1.667h1.3c2.154 0 3.9 1.79 3.9 4V45c0 2.21 1.746 4 3.9 4s3.9-1.79 3.9-4V22.333L45.8 17", "stroke-opacity": ".8", stroke: color }),
            react_1.default.createElement(react_native_svg_1.G, null,
                react_1.default.createElement(react_native_svg_1.Path, { d: "M40 47h24v24H40z" }),
                react_1.default.createElement(react_native_svg_1.Path, { stroke: tickColor, "stroke-linecap": "square", d: "m46 58.917 4.554 4.583 8.196-8.25" })))));
};
GasPumpWithTick.defaultProps = {
    color: '#111111',
    tickColor: '#35E896',
    width: 64,
    height: 71,
};
exports.default = react_1.default.memo(GasPumpWithTick);
